import axios from "axios";
import CommonApi from "./CommonApi";


export default class StatisticApi {
    static async getGoAroundData(){
        const res=await axios.get( CommonApi.getHost()+"/GoAround/getGoAroundData")
        return res.data;
    }
    static async getWorks(){
        const res=await axios.get( CommonApi.getHost()+"/ConstructionSite/getWorks")
        return res.data;
    }
    static async getImagesDates(){
        const res=await axios.get( CommonApi.getHost()+"/GoAround/getImagesDates")
        return res.data;
    }
    static async getImages(Date){
        const params={
            params:{
                Date:Date
            }
        }
        const res=await axios.get( CommonApi.getHost()+"/ConstructionSite/getWorks", params)
        return res.data;
    }
}